import { getJSON } from '../api';


type TenantsModuleArgs = [
  url: string
];
type Module = {
  type: string;
  open_or_not: '0' | '1',
  tnt_id: string;
  created_time: Date;
  update_time: Date;
}
type TenantsModuleResponse = Module[];

type ModuleTypeList = {
  types: string[],
  data: {[type: string]: Module}
}

export function getTenantsModuleArgs(
  props: { tid: string}
): TenantsModuleArgs {
  const { tid } = props;
  if ((tid ?? null) === null) {
    return null;
  }
  const url = `tenants/${tid}/getTenantsModule`;
  return [url];
}

export async function getTenantsModuleAction(
  args: TenantsModuleArgs
): Promise<ModuleTypeList> {
  const [url] = args;
  const res = await getJSON<TenantsModuleResponse>({url});
  return res.reduce<ModuleTypeList>((acc, item) => {
    const { type } = item;
    acc.types.push(type);
    acc.data[type] = item;
    return acc;
  }, { types: [], data: {} } as ModuleTypeList);
}
